import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-stone-100 px-5 py-16 sm:py-20" data-id="element-97" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-xl text-center" data-id="element-98" data-mp="1o5q24hrrqa0i">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-red-500" data-id="element-99" data-mp="223ofbjucs0ef">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-100" data-mp="1x5mvgwp3rx1w" />
        </span>
        <h2 className="mt-6 text-xl font-black uppercase tracking-wide text-stone-900 sm:text-2xl" data-id="element-101" data-mp="19dzd535wpub8">
          Get Your Money Back Or Keep It
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-stone-600" data-id="element-102" data-mp="14dl53l4b2kd7">
          7-day no-questions-asked guarantee. If it&apos;s not what you expected
          or doesn&apos;t save you hours of work, we&apos;ll refund you. Just
          email us.
        </p>
        
      </div>
    </section>;
}